
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { BIconPrinter } from "bootstrap-vue";
import { Accordion, AccordionItem } from "@/components/Accordion";
import DocsUpload from "@/components/DocsUpload.vue";
import { VueFilePondComponent } from "vue-filepond";
import { getBenefactorName } from "@/utils/HelperFunctions";
import FileConfig from "../../FileConfig";
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import VueHtml2pdf from "vue-html2pdf";
import BenefactorsRequiredDocuments from "./BenefactorsRequiredDocuments.vue";
import CodTipoDocumento from "@/enums/CodTipoDocumento";

@Component({
  components: {
    Accordion,
    AccordionItem,
    DocsUpload,
    BIconPrinter,
    VueHtml2pdf,
    BenefactorsRequiredDocuments,
  },
})
export default class SubirDocumentacion extends Vue {
  @Prop({ default: [] }) benefactors: Benefactor[];
  @Prop({ default: [] }) generalDocs: BenefactorDocument[];
  @Prop({default:""}) cedulaFallecido:string;
  public documentos: Array<File> = [];
  public showFileRequiredError: boolean = false;
  public showInvalidFileTypeError: boolean = false;
  public showInvalidFileSizeError: boolean = false;
  public showServerValidationMessage: boolean = false;
  public serverValidationMessage = "";
  public fileConfig: FileConfig = new FileConfig();
  public benefactorsNames: string[] = [];
  public getBenefactorName = getBenefactorName;
  public isAnyDocPending = true;

  @Watch("showInvalidFileTypeError")
  public async onInvalidFileType(newValue, oldValue) {
    let invalidClass = "invalid-file";
    let element = (this.$refs.pond as VueFilePondComponent).$el as HTMLElement;
    if (newValue) {
      let classList = element.className.split(" ");
      if (classList.indexOf(invalidClass) == -1) {
        element.className += " " + invalidClass;
      }
    } else {
      let classList = element.className.split(" ");
      let classIndex = classList.indexOf(invalidClass);
      classList.splice(classIndex, 1);
      element.className = classList.join(" ");
    }
  }
  generateReport() {
    (this.$refs.html2Pdf as any).generatePdf();
  }

  updateBenefactorDocs(
    documents: BenefactorDocument[],
    benefactorPosition: number
  ) {
    this.benefactors[benefactorPosition].documents = documents;
    this.getIsAnyDocPending();
  }

  handleBenefactorNameChange(e, index) {
    const namesToChange = [
      "primerNombre",
      "segundoNombre",
      "primerApellido",
      "segundoApellido",
    ];
    const nameValues = e.target.value.split(" ");

    nameValues.forEach((name, index) => {
      this.benefactors[index][namesToChange[index]] = name.toUpperCase();
    });
  }
  public OpenBeneficiario(value) {
    // console.log("Subir documetnacion Emite:" + value);
    this.$emit("OpenBeneficiario", value);
  }

  @Watch("generalDocs")
  public getIsAnyDocPendingOnGeneralChanged(){
    this.getIsAnyDocPending()
  }
  
  @Watch("benefactors")
  public getIsAnyDocPending(){
    // console.log("function getIsAnyDocPending")
    let generalPending = this.generalDocs.some(x => x.link == null && x.estRecepDoc =="P");
    let benefePending = false;
    // console.log("function getIsAnyDocPending 2 ")
    // console.table(this.benefactors);
     if(this.benefactors && this.benefactors.length>0){
       for(let beneficiario of this.benefactors){
        //  console.log("documento ")
        // console.table(beneficiario.documents)
        if(beneficiario.documents != null && beneficiario.documents.length>0){
           for(let document of beneficiario.documents){
              if(document.link == null && document.estRecepDoc =="P" &&(document.codTipDocumento != CodTipoDocumento.ComprobanteDeCuenta)){
              benefePending = true;
              break; 
            }
        }
        }

        // console.log("function getIsAnyDocPending ii")
        if(benefePending == true) break;
      }
     }

  // console.log("General pending",generalPending,"benef pending",benefePending)
  this.$emit("isAnyDocPendingChanged",(generalPending || benefePending ))
  
  }
}
